import { Route } from '@angular/router';
import { LoginAsAnyoneComponent } from '@auth/components/login-as-anyone/login-as-anyone.component';
import { LogoutComponent } from '@auth/components/logout/logout.component';
import { PageUrls } from '@constants/page-urls.constants';
import { DevEnvGuard } from '@guards/dev-env/dev-env.guard';

export const auth_routes: Route[] = [
  {
    path: PageUrls.LOGIN.replace('/auth/', ''),
    component: LoginAsAnyoneComponent,
    canActivate: [DevEnvGuard],
    title: 'Connected'
  },
  {
    path: PageUrls.LOGOUT.replace('/auth/', ''),
    component: LogoutComponent,
    title: 'Disconnected'
  }
];
